import { property } from 'lit/decorators.js'
import { nothing } from 'lit'

import { LfuiElement } from '#utils/element'

/**
 * Internal notification from an option (or an optgroup) to the select that owns
 * it: re-render. Namespaced so an author listening for `change` on an option is
 * not handed an internal signal instead of a value change.
 */
export const OPTION_CHANGE_EVENT = 'lfds-option-change'

/**
 * @name LfdsSelectOption
 * @tag lfds-select-option
 * @status beta
 *
 * @description
 * Option element for use inside `lfds-select`.
 *
 * The content of an option is **text only**. Set the text either as the
 * element's own text content or through the `label` property — `label` wins
 * when both are present. Element children are ignored, and warned about in
 * development builds.
 */
export default class LfdsSelectOption extends LfuiElement {
	@property() value: string
	@property() label!: string
	@property({ type: Boolean }) selected: boolean = false
	@property({ type: Boolean }) disabled: boolean = false

	updated(changed) {
		this.dispatchEvent(
			new CustomEvent(OPTION_CHANGE_EVENT, { detail: changed })
		)
	}

	render() {
		return nothing
	}
}
